import { MealFormType, MealItemType, SectionType } from 'models/production-report.model';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import { apiService } from 'services/base.service';
import { ALL, STORAGE_KEYS } from 'utils/constants';
import { ProductionReportContext } from './context';
import { ActiveType } from 'models/vendors.model';

const allItem = { name: 'All', id: ALL } as SectionType;

const ProductionReportProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);

  const [sections, setSections] = useState<SectionType[]>([allItem]);
  const [loading, setLoading] = useState(false);
  const [activeSection, setActiveSection] = useState({} as SectionType);
  const [mealFormData, setMealFormData] = useState<MealFormType[]>([]);
  const [active, setActive] = useState<ActiveType | null>(null);
  const [isBackLink, setIsBackLink] = useState(false);
  const [backLinkTitle, setBackLinkTitle] = useState('');
  const [selectedMeals, setSelectedMeals] = useState<MealItemType[]>([]);

  useEffect(() => {
    loadSections();
  }, []);
  useEffect(() => {
    if (sections.length > 0) {
      setActiveSection(sections[0]);
    }
  }, [sections]);

  const loadSections = async () => {
    try {
      setLoading(true);
      const res = await apiService.get(`cokitchen-item/cokitchen/${cokitchenId}/sections`);
      const { data } = res;

      setSections([allItem, ...data]);
    } finally {
      setLoading(false);
    }
  };
  return (
    <ProductionReportContext.Provider
      value={{
        sections,
        setSections,
        activeSection,
        setActiveSection,
        loading,
        setLoading,
        isBackLink,
        setIsBackLink,
        backLinkTitle,
        setBackLinkTitle,
        mealFormData,
        setMealFormData,
        active,
        setActive,
        selectedMeals,
        setSelectedMeals
      }}>
      {children}
    </ProductionReportContext.Provider>
  );
};

export default ProductionReportProvider;
